var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2778_1689",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19L9.5 9.5L0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5L10.2071 10.2071C10.5976 9.81658 10.5976 9.18342 10.2071 8.79289L9.5 9.5ZM0.707107 19.7071L10.2071 10.2071L8.79289 8.79289L-0.707107 18.2929L0.707107 19.7071ZM10.2071 8.79289L0.707107 -0.707108L-0.707107 0.707108L8.79289 10.2071L10.2071 8.79289Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2778_1689)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow1.b907df114cd8984521d3987d79e9af78.svg";
export { ForwardRef as ReactComponent };